import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Card } from 'semantic-ui-react';
import SelectableCard from '@/components/cards/SelectableCard';
import CardItemDescription from '@/components/cards/CardItemDescription';
import CardItem from '@/components/cards/CardItem';
import TokenCardHeader from './TokenCardHeader';
import TokenCardItemExtra from './TokenCardItemExtra';
import TokenTools from '../containers/TokenTools';

const TokenCardItem = ({
  category,
  token,
  upward,
  allowUserLink,
  onCheckBoxClick,
  single,
}) => (
  <CardItem className="aridhia-token-list-item">
    <Card.Content>
      <SelectableCard
        className="aridhia-card-header"
        onClick={onCheckBoxClick ? () => onCheckBoxClick(token.code) : undefined}
        selected={token.selected}
        single={single}
      >
        <TokenCardHeader token={token} />
        <TokenTools
          iconSize="large"
          upward={upward}
          category={category}
          token={token}
          listItem
        />
      </SelectableCard>
      <Card.Meta>
        <FormattedMessage id="valid.range.date" values={{ from: token.createdOn, to: token.expiresOn }} />
      </Card.Meta>
      <CardItemDescription value={token.description} markdown />
    </Card.Content>
    <TokenCardItemExtra token={token} allowUserLink={allowUserLink} category={category} />
  </CardItem>
);

export default TokenCardItem;
